import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export interface ISendProjectInvestmentInfoServiceArgs {
    reportingDate: string;
    reportingYear: number;
    adjNumber: number;
    hasInvestmentProject: number;
}

export const sendProjectInvestmentInfoService = async ({
    reportingDate,
    reportingYear,
    adjNumber,
    hasInvestmentProject,
}: ISendProjectInvestmentInfoServiceArgs) => (
    performRequest({
        url: `v3/submitInvestmentProject`,
        method: ERequestType.POST,
        data: JSON.stringify({
            reportingDate,
            reportingYear,
            adjNumber,
            hasInvestmentProject,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
);

